import type { Socket } from "socket.io-client";

export function attachExpirySocketHandlers(
  socket: Socket,
  deps: {
    markExpiredNow: (ids: string[], parentId?: string) => void;
    expiredRef: { current: { parentId?: string; ids: string[] } | null };
  }
) {
  const onExpired = (p: any) => {
    const ids: string[] = Array.isArray(p?.ids) ? p.ids.map(String) : [];
    const parentId = p?.parentId ? String(p.parentId) : undefined;
    if (!ids.length) return;

    // remember → so future fetch/socket merges can apply the flag too
    const prev = deps.expiredRef.current;
    const merged = new Set([...(prev?.ids || []), ...ids]);
    deps.expiredRef.current = { parentId, ids: Array.from(merged) };

    // flip UI now
    deps.markExpiredNow(ids, parentId);
  };

  socket.on("message_expired", onExpired);
  return () => socket.off("message_expired", onExpired);
}


export function applyAlbumManifestInPlace(m: any) {
  try {
    const t = (m.decryptedText ?? "").trim();
    if (!t) return;

    const j = JSON.parse(t);
    if (!j || j.kind !== "album") return;

    if (Array.isArray(j.items) && j.items.length) {
      m.albumItems = j.items;
    }
    if (Array.isArray(j.ids) && j.ids.length) {
      m.albumIds = j.ids.map(String);
    }

    console.log("[album] parsed for msg", m._id, {
      hasItems: !!m.albumItems,
      itemsLen: m.albumItems?.length,
      hasIds: !!m.albumIds,
      idsLen: m.albumIds?.length,
    });

    m.decryptedText = "";
  } catch (e) {
    console.warn("[album manifest parse] failed for msg", m?._id, e);
  }
}
